import React, { useState } from 'react';
import { useParams } from 'react-router';

import usePublicApi from 'public-api';
import { isResponse } from 'public-api/utils';
import { useAsyncFunction } from 'stores/hooks';
import { Button, Segment } from 'ui';

function TicketUnsubscribe() {
  const { ticketId, hashcode } = useParams<{ ticketId: UUIDField; hashcode: UUIDField }>();
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<null | string>(null);
  const api = usePublicApi();

  const send = async () => {
    try {
      await api.ClientTicketUnsubscribeApi.create({ id: ticketId!, hashcode: hashcode! });
      setSuccess(true);
    } catch (error) {
      if (isResponse(error)) {
        setError(await error.response.text());
      }
    }
  };

  const [handleSend, isSending] = useAsyncFunction(send);

  return success ? (
    <Segment padded>
      <div className="space-y-4">
        <h3 className="text-2xl font-medium">{gettext('Your address has been unsubscribed')}</h3>
        <p>{gettext('We will not send you any further messages.')}</p>
      </div>
    </Segment>
  ) : (
    <Segment>
      <div className="space-y-4">
        <h3 className="text-2xl font-medium">{gettext('Unsubscribe')}</h3>
        <p>{gettext('Click the button below to unsubscribe from further emails.')}</p>
        <p>
          {gettext(
            'Please keep in mind that the shop will not be able to inform you about further developments of your ticket. This can make processing your ticket longer.',
          )}
        </p>
        {error ? (
          <>
            <Segment>{error}</Segment>
            <Segment>
              {gettext(
                'We were not able to unsubscribe you from your ticket automatically. Please contact our support.',
              )}
              <br />
              <Button>
                <a href="mailto:support@retino.com">support@retino.com</a>
              </Button>
            </Segment>
          </>
        ) : (
          <Button loading={isSending} onClick={handleSend}>
            {gettext('I understand the risks. Unsubscribe.')}
          </Button>
        )}
      </div>
    </Segment>
  );
}

export default TicketUnsubscribe;
